import { featuredImages } from '@/mocks/images';

export default function ResourceCenter() {
  const resources = [
    { icon: 'ri-file-list-3-line', title: 'Sugargoo Spreadsheet', desc: 'Browse the complete database of curated product finds.', color: 'bg-primary-100 text-primary-600', image: featuredImages.resourceSpreadsheet },
    { icon: 'ri-star-line', title: 'Sugargoo Reviews', desc: 'Read real user experiences and detailed platform reviews.', color: 'bg-accent-100 text-accent-600', image: featuredImages.resourceReviews },
    { icon: 'ri-ship-line', title: 'Sugargoo Shipping Cost', desc: 'Understand shipping methods, pricing, and delivery times.', color: 'bg-secondary-100 text-secondary-600', image: featuredImages.resourceShipping },
    { icon: 'ri-building-4-line', title: 'Sugargoo Warehouse Guide', desc: 'Learn how Sugargoo warehouse and consolidation work.', color: 'bg-primary-100 text-primary-600', image: featuredImages.resourceWarehouse },
    { icon: 'ri-coupon-line', title: 'Sugargoo Coupon Codes', desc: 'Find the latest discount codes and saving strategies.', color: 'bg-accent-100 text-accent-600', image: featuredImages.resourceCoupon },
    { icon: 'ri-shield-check-line', title: 'Is Sugargoo Legit?', desc: 'Complete safety and legitimacy analysis before you buy.', color: 'bg-secondary-100 text-secondary-600', image: featuredImages.resourceLegit },
  ];

  return (
    <section id="resources" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 mb-5">
            <span className="text-xs font-medium text-accent-700 tracking-wide">Resources</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Complete Sugargoo Resource Center
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Everything you need to become a Sugargoo shopping expert, all in one place.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {resources.map((res) => (
            <a
              key={res.title}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer h-48"
            >
              <img
                src={res.image}
                alt={res.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/25 to-black/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-start gap-3">
                  <div className={`w-9 h-9 flex items-center justify-center rounded-lg ${res.color} flex-shrink-0`}>
                    <i className={`${res.icon} text-sm`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-background-50 mb-1 whitespace-nowrap">
                      {res.title}
                    </h3>
                    <p className="text-xs text-background-50/70 leading-relaxed">{res.desc}</p>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}